module.exports = __webpack_public_path__ + "img/coating-reflection-cover.451a97e8.png";